import AuthSettingsStore from '../../AuthSettingsStore';
import UserStore from '../../UserStore';
import BaseFilesManager from './BaseFilesManager';
import FilesListLoader from '../FilesListLoader';
import { SecuredFile } from '../../../types/types';
import { FilesListType, FolderLike } from '../interfaces';
import { FILE_META_ORDERING_FIELDS } from '../options';

class MyFilesManager extends BaseFilesManager {
    constructor(
        filesListType: FilesListType,
        authSettingsStore: AuthSettingsStore,
        userStore: UserStore,
        filesListLoader: FilesListLoader,
    ) {
        super('myFiles', authSettingsStore, userStore, filesListLoader, [...FILE_META_ORDERING_FIELDS]);
    }

    /*
    * Workspaces
    * */
    protected setCurrentFolderFiles(newList: SecuredFile[]): void {
        super.setCurrentFolderFiles(newList.filter((item) => !item.is_workspace));
    }

    protected setFolderFiles(folder: FolderLike, newList: SecuredFile[]): void {
        super.setFolderFiles(folder, newList.filter((item) => !item.is_workspace));
    }
}

export default MyFilesManager;
